import {
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
    GET_PRICES_FOR_ITEMS,
    RESET_PRICES_FOR_ITEMS,
    SET_ITEMS_DURING_PRICING,
} from '../actions';

const initialState = {
    pricedItems: null,
    isPricingDone: false,
    pricesForItemsLoading: false,
    itemsToBePriced: [],
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const getPricesForItemsConsignmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRICES_FOR_ITEMS:
            return {
                ...state,
                // pricedItems: [],
                isPricingDone: false,
                pricesForItemsLoading: true,
            };
        case GET_PRICES_FOR_ITEMS_SUCCESS:
            return {
                ...state,
                pricedItems: action.payload.items,
                isPricingDone: true,
                pricesForItemsLoading: false,
            };
        case GET_PRICES_FOR_ITEMS_FAILURE:
            return {
                ...state,
                pricedItems: action.payload.items,
                isPricingDone: false,
                pricesForItemsLoading: false,
            };
        case 'SET_PRICING_DONE_FLAG': {
            return { ...state, isPricingDone: action.payload };
        }
        case RESET_PRICES_FOR_ITEMS:
            return {
                ...state,
                ...initialState,
            };
        case SET_ITEMS_DURING_PRICING:
            return {
                ...state,
                itemsToBePriced: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentGetPricesForItemsKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    getPricesForItemsConsignmentReducer
);
